const qrCodesSliders = () => {
	const orderQrSliders = $('.js-order-qr-code-slider');
	const orderQrSlidersShowButtons = $(".js-qr-codes-slider-modal-show-button");

	const updateValues = (currentSlider, changeValueSelector, newValueSelector) => {
		$(currentSlider)
			.find(changeValueSelector)
			.text($(currentSlider).find(".swiper-slide-active").attr(newValueSelector));
	}

	$(orderQrSliders).each((i, slider) => {
		const swiper = new Swiper(slider, {
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			}
		});

		swiper.on('slideChange', function() {
			setTimeout(() => {
				updateValues(this.el, ".js-event-name", "data-title");
				updateValues(this.el, ".js-ticket-count", "data-count");
				updateValues(this.el, ".js-max-ticket-count", "data-max-event-tickets-count");
			}, 100)
		});

		$(slider)
			.parents(".qr-codes-slider-modal")
			.find(".js-qr-codes-slider-close-button")
			.on("click", () => $(slider).parents(".qr-codes-slider-modal").addClass("inactive"));
	});

	$(orderQrSlidersShowButtons).each((i, showButton) => {
		$(showButton).on("click", () => {
			$(showButton)
				.parents(".order-table__body")
				.find(".qr-codes-slider-modal")
				.removeClass("inactive")
		});
	});
}

export default qrCodesSliders;
